import reducerRegistry from 'reduxUtils/reducerRegistry';

const reducerName = 'schema';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_SCHEMA_DATA = createActionName('RECEIVE_SCHEMA_DATA');

export function receiveSchemaData(data) {
  return {
    type: RECEIVE_SCHEMA_DATA,
    payload: {
      ...data,
    },
  };
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_SCHEMA_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
